/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Is_PublishedInputs */

const en_label_is_published = /** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicly Visible`)
};

const es_label_is_published = /** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Públicamente Visible`)
};

const fr_label_is_published = /** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible publiquement`)
};

const de_label_is_published = /** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentlich sichtbar`)
};

const id_label_is_published = /** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlihat Publik`)
};

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const ja_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const zh_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const ar_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const it_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const ru_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const pt_label_is_published = en_label_is_published;

/** @type {(inputs: Label_Is_PublishedInputs) => LocalizedString} */
const ko_label_is_published = en_label_is_published;

/**
* | output |
* | --- |
* | "Publicly Visible" |
*
* @param {Label_Is_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_is_published = /** @type {((inputs?: Label_Is_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Is_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_is_published(inputs)
	if (locale === "es") return es_label_is_published(inputs)
	if (locale === "fr") return fr_label_is_published(inputs)
	if (locale === "de") return de_label_is_published(inputs)
	if (locale === "ja") return ja_label_is_published(inputs)
	if (locale === "zh") return zh_label_is_published(inputs)
	if (locale === "ar") return ar_label_is_published(inputs)
	if (locale === "id") return id_label_is_published(inputs)
	if (locale === "it") return it_label_is_published(inputs)
	if (locale === "ru") return ru_label_is_published(inputs)
	if (locale === "pt") return pt_label_is_published(inputs)
	return ko_label_is_published(inputs)
});